import axios from "axios";

/** The API answers 404 for a retailer that is unknown or no longer a retailer in Shopify. */
export const isNotFoundError = (error: unknown): boolean =>
  axios.isAxiosError(error) && error.response?.status === 404;
